/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import CreateCustomerSupplyRequest from '../model/CreateCustomerSupplyRequest';
import CreateCustomerSupplyResponse from '../model/CreateCustomerSupplyResponse';
import ErrorResponse from '../model/ErrorResponse';
import GetUploadStatusResponse from '../model/GetUploadStatusResponse';
import SearchCustomerSupplyResponse from '../model/SearchCustomerSupplyResponse';
import UploadSupplyCsvResponse from '../model/UploadSupplyCsvResponse';

/**
* Supplies service.
* @module api/SuppliesApi
* @version 2020-12-7
*/
export default class SuppliesApi {

    /**
    * Constructs a new SuppliesApi. 
    * @alias module:api/SuppliesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * 給油量を登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateCustomerSupplyResponse} and HTTP response
     */
    createCustomerSupplyWithHttpInfo(body, customerId) {
      let postBody = body;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateCustomerSupplyResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/supplies', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 給油量を登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateCustomerSupplyResponse}
     */
    createCustomerSupply(body, customerId) {
      return this.createCustomerSupplyWithHttpInfo(body, customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    customersIdSupplyPreflightWithHttpInfo(customerId) {
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/customers/{customerId}/supplies', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    customersIdSupplyPreflight(customerId) {
      return this.customersIdSupplyPreflightWithHttpInfo(customerId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 給油CSVの登録情報を取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetUploadStatusResponse} and HTTP response
     */
    getSupplyCsvUploadStatusWithHttpInfo(groupId, uploadStatusId) {
      let postBody = null;

      let pathParams = {
        'groupId': groupId,
        'uploadStatusId': uploadStatusId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetUploadStatusResponse;

      return this.apiClient.callApi(
        '/groups/{groupId}/supply-csv/{uploadStatusId}/status', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 給油CSVの登録情報を取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetUploadStatusResponse}
     */
    getSupplyCsvUploadStatus(groupId, uploadStatusId) {
      return this.getSupplyCsvUploadStatusWithHttpInfo(groupId, uploadStatusId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 給油量を取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchCustomerSupplyResponse} and HTTP response
     */
    searchCustomerSuppliesWithHttpInfo(customerId, opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        'customerId': customerId
      };
      let queryParams = {
        'from': opts['from'],
        'to': opts['to']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchCustomerSupplyResponse;

      return this.apiClient.callApi(
        '/customers/{customerId}/supplies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 給油量を取得する
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchCustomerSupplyResponse}
     */
    searchCustomerSupplies(customerId, opts) {
      return this.searchCustomerSuppliesWithHttpInfo(customerId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * 給油情報をCSVで一括登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UploadSupplyCsvResponse} and HTTP response
     */
    uploadSupplyCsvWithHttpInfo(body, groupId) {
      let postBody = body;

      let pathParams = {
        'groupId': groupId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['text/csv'];
      let accepts = ['application/json'];
      let returnType = UploadSupplyCsvResponse;

      return this.apiClient.callApi(
        '/groups/{groupId}/supply-csv', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * 給油情報をCSVで一括登録する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UploadSupplyCsvResponse}
     */
    uploadSupplyCsv(body, groupId) {
      return this.uploadSupplyCsvWithHttpInfo(body, groupId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
